import { createContext } from 'react';

import { ComparisonState } from './comparison-state.model';

export const ComparisonContext = createContext<ComparisonState | undefined>(undefined);

ComparisonContext.displayName = 'ComparisonContext';
